// extracted by mini-css-extract-plugin
export default {"container":"_371175ff","warningIcon":"_922992d9"};